<template>
    <ion-page>
        <standard-header :title="title" align="middle"/>
        <ion-content>
            <skeleton :rows="4" v-if="items === null" />
            <ion-searchbar v-else animated mode="ios" v-model="filter" />
            <pull-down-refresh :callback="refresh"/>
            <ion-list v-if="items">
                <ion-item
                    lines="none"
                    v-for="item in filteredItems"
                    :key="item.id"
                    button
                    detail
                    @click="move(item)"
                >
                    <ion-avatar class="ion-justify-content-center ion-align-items-center">
                        {{ getTotalQuantity(item) }}
                    </ion-avatar>
                    <ion-label class="ion-text-wrap">
                        <h2>{{ item.name }}</h2>
                        <p>{{ item.item_number }}</p>
                    </ion-label>
                </ion-item>
            </ion-list>
        </ion-content>
    </ion-page>

</template>

<script>
import StandardHeader from "@/components/StandardHeader";
import {
    IonContent,
    IonItem,
    IonLabel,
    IonList,
    IonPage,
    IonSearchbar,
    IonAvatar, modalController
} from "@ionic/vue";
import PullDownRefresh from "@/components/PullDownRefresh";
import _ from 'lodash';
import Skeleton from "@/components/Skeleton";
import MoveModal from "@/views/modules/warehouse/stack/MoveModal";

export default {
    name: "ItemList",
    inject: ['$http', '$toast', '$validationAlert', '$scanner'],
    components: {
        Skeleton,
        PullDownRefresh,
        StandardHeader,
        IonContent, IonItem, IonLabel, IonList, IonPage,
        IonSearchbar,
        IonAvatar
    },
    computed: {
        title() {
            return `Return at ${this.query.locationCode}`
        },
        params() {
            return this.$route.params;
        },
        query() {
            return this.$route.query;
        },
        filteredItems() {
            return _.filter(this.items, item => {
                let found = 0;
                found += item.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1;
                found += item.item_number.toLowerCase().indexOf(this.filter.toLowerCase()) > -1;
                found += _.map(item.skus, 'sku').join('|').toLowerCase().indexOf(this.filter.toLowerCase()) > -1;
                found += _.map(item.skus, 'barcode').join('|').toLowerCase().indexOf(this.filter.toLowerCase()) > -1;
                return found > 0;
            });
        },
    },
    methods: {
        /**
         * Because we've filtered our responses by locationId, we should be able to
         * grab the selected item, look through its locations (which, again, should be
         * filtered down to just locationId) and grab whichever location matches our
         * param.
         *
         * @param item
         * @returns {unknown}
         */
        location(item) {
            return _.find(item.locations, location => {
                // not triple === because of type differences between params and model ids
                return location.id == this.params.locationId;
            });
        },
        ionViewDidEnter() {
            this.refresh();
        },
        refresh(event) {
            this.items = null;
            this.$http.get('/api/stack/items', {
                params: {all: true, include: 'locations,locations.pivot,skus', returns_only: true, location_id: this.params.locationId}
            }).then(response => {
                this.items = response.data.items;
            }).catch(error => {
                this.$validationAlert(error);
                this.items = [];
            }).finally(() => {
                if (event && event.target.complete) {
                    event.target.complete();
                }
            });
        },
        getTotalQuantity(item) {
            // in theory, this shouldn't be necessary, but we're going to sum
            // the qty_total of every location which matches this.params.locationId
            return _.sum(_.map(item.locations, location => {
                return location.id == this.params.locationId?location.pivot.qty_total:0;
            }));
        },
        move(item) {
            const componentProps = {
                initMode: 'stack',
                item: item,
                source: this.location(item),
                confirmLabel: 'Move Items'
            };

            console.log(componentProps);

            modalController.create({
                component: MoveModal,
                componentProps
            }).then(modal => {
                modal.present();
                modal.onDidDismiss()
                    .then(response => {
                        if (response.data) {
                            this.refresh();
                        }
                    });
            });
        }
    },
    data() {
        return {
            filter: '',
            items: null
        }
    }

}
</script>
<style>
ion-avatar {
    border-radius: 50%;
    background-color: var(--ion-color-primary);
    color: var(--ion-color-primary-contrast);
    font-weight: bold;
    display:flex;
}
</style>
